<template>
    <div class="page gc">
        <SideMenu />

        <div class="page-content g9">
            <h2>Users</h2>
            <div class="accord" v-bind:class="{ 'closed': isClosed }">
                <header v-on:click="onToggle">Users<span title="open / close"></span></header>
                <article v-if="!isClosed">
                    <slot>
                        <div class="grid-100w">
                            <table class="list">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Created</th>
                                        <th>LastLogin</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th>Locked</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="member in members">
                                        <td>
                                            <router-link :to="'/member/edit/' +member.memberId">
                                                {{ member.firstName }} {{ member.lastName }}
                                            </router-link>
                                        </td>
                                        <td>{{ member.createDateString }}</td>
                                        <td>{{member.lastSuccessfulValidationUtcString}}</td>
                                        <td>{{ member.email }}</td>
                                        <td>{{ member.memberRoleName }}</td>
                                        <td>
                                            <div v-if="member.isLocked">
                                                yes
                                            </div>
                                            <div v-else>
                                                no
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </slot>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
    import API from "../../Api"
    import SideMenu from "../Components/SideMenuMembers.vue"
    import FormBuilder from "../Components/FormBuilder.vue"    
   

    export default {
        components: {
            SideMenu,
            FormBuilder            
        },
        data: () => ({
            isLoading: false,
            isClosed: false,
            members: []
        }),
       
        mounted() {            
            this.$store.dispatch("getMemberList").then((res) => {
                this.members = res;
            });
        },
        methods: {
             onToggle() {
                this.isClosed = !this.isClosed
            },
            onAnchorClick(e){
                e.preventDefault();
            }
        }
    }
</script>
